// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"HQ-z","categoryName":"IQ-z","categoryNameSearchHeader":"JQ-z","categoryContent":"KQ-z","bottomAligned":"LQ-z","image":"MQ-z","imageNoBackground":"NQ-z"};